const Report = () =>
  import(
    /* webpackChunkName: "base-info-reason" */ '@/pages/base-info/reason/reasons/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-reason" */ '@/pages/base-info/reason/reasons/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-reason" */ '@/pages/base-info/reason/reasons/edit.vue'
  )

export default {
  path: 'reasons',
  meta: {
    label: 'reasons',
    auth: 'reason'
  },
  component: {
    name: 'Reasons',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoReason',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateReason',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditReason',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
